<template>
  <li class="nav-item hidden-mobile nav-loader">
    <div :style="{display}">
      <span>
        <i class="fa fa-refresh fa-spin fa-fw"></i>
        <span v-if="isDebug">{{ lastRunningTaskText }}</span>
      </span>
    </div>
  </li>
</template>

<script>
  export default {
    name: 'li-loader',
    computed: {
      lastRunningTaskText () {
        let task = this.$store.getters['app/tasks/lastRunning']
        return task ? task.name : ''
      },
      runningTasks () {
        return this.$store.getters['app/tasks/running']
      },
      display () {
        return this.runningTasks.length > 0 ? 'block' : 'none'
      },
      isDebug () {
        return this.$store.getters['users/current'].id === 1
      }
    }
  }
</script>

<style>
  .nav-loader {
    padding-top: 25px;
  }

  .nav-loader span {
    padding-left: 25px;
    margin-right: 10px;
    color: #818a91;
    font-size: 0.8em;
  }
</style>



// WEBPACK FOOTER //
// LiLoader.vue?78cb9d5c